/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesFormDataInputQuestionDataSubtypeSchema = z.union([
	z.literal('name'),
	z.literal('email'),
	z.literal('phone'),
	z.literal('multiple'),
	z.literal(null),
])

export type ModulesFormDataInputQuestionDataSubtypeSchema = z.infer<
	typeof modulesFormDataInputQuestionDataSubtypeSchema
>
